import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

import { Observable } from 'rxjs';
import { date } from 'src/utils/date';
import { formatDate } from '@angular/common';
import { AppConfigService, AppConfig } from '../services/app-config.service';
import { AuthService } from '../auth/auth.service';
import { AftercareSettingsQuestionGroupDTO } from 'src/DTOs/Organisations/Models/AftercareSettingsQuestionGroupDTO';
import { AppointmentCreateDto } from 'src/DTOs/PatientProcedures/Models/AppointmentCreateDto';
import { Moment } from 'moment';
import { AppointmentSuggestedReply } from 'src/DTOs/PatientProcedures/Models/AppointmentSuggestedReply';

@Injectable()
export class PatientProceduresService implements OnInit {

    public appConfig: AppConfig = new AppConfig();

    constructor(private http: HttpClient,
        private appConfigService: AppConfigService) {

        this.appConfig = this.appConfigService.getConfig();

    }

    ngOnInit(): void { }


    //-----------------------------------------------------------
    //getPatientProceduresList - begin
    //-----------------------------------------------------------
    getPatientProceduresList(
        orgId: string,
        dateFrom: Moment,
        dateTo: Moment,
        centerId: string,
        doctorIds: string[],
        treatmentIds: string[],
        name: string,
        currentPage: number = 1,
        pageLimit: number = 20,
        hideCancelled: boolean = true): Observable<any> {

        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "patientprocedureslist?organisationId=" + orgId

        url += "&dateFrom=" + dateFrom.format("YYYY-MM-DDTHH:mm");
        url += "&dateTo=" + dateTo.format("YYYY-MM-DDTHH:mm");

        if (centerId != "") {
            url += "&centerId=" + centerId
        }

        if ((doctorIds != undefined) && (doctorIds.length > 0)) {
            url += "&doctorIds=" + doctorIds.join();
        }
        if ((treatmentIds != undefined) && (treatmentIds.length > 0)) {
            url += "&procedureIds=" + treatmentIds.join();
        }

        if (name != "") {
            url += "&name=" + name;
        }

        url += "&currentPage=" + currentPage + "&pageLimit=" + pageLimit + "&hideCancelled=" + (hideCancelled ? 'true' : 'false');

        if (environment.debug_mode) {
            console.log("getPatientProceduresList: " + url);
        }

        return this.http.get(url);

    }
    //-----------------------------------------------------------
    //getPatientProceduresList - end
    //-----------------------------------------------------------

    //-----------------------------------------------------------
    //get PatientProcedures - begin
    //-----------------------------------------------------------
    getPatientProcedures(patientId: string): Observable<any> {

        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "patientprocedures?patientId=" + patientId;

        if (environment.debug_mode) {
            console.log("getPatientProcedures: " + url);
        }

        return this.http.get(url)

    }
    //-----------------------------------------------------------
    //get PatientProcedures - end
    //-----------------------------------------------------------    


    //-----------------------------------------------------------
    //get PatientProcedureDays with ActionLog - begin
    //-----------------------------------------------------------   

    getPatientProcedureDaysDetails(patientprocedureid: string): Observable<any> {

        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "patientproceduredaysdetails?patientprocedureid=" + patientprocedureid;

        if (environment.debug_mode) {
            console.log("getPatientProcedureDaysDetails url: " + url);
        }
        return this.http.get(url);
    }

    //-----------------------------------------------------------
    //get PatientProcedureDays with ActionLog- end
    //-----------------------------------------------------------     

    getQuestionGroups(): Observable<any> {
        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "questiongroups";

        return this.http.get(url);
    }

    putQuestionGroups(questionGroups: AftercareSettingsQuestionGroupDTO[]): Observable<any> {
        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "questiongroups";

        return this.http.put(url, questionGroups);
    }

    getSurveyResultsGroupedByQuestions(procedureId: string): Observable<any> {
        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "compare?patientProcedureId=" + procedureId;

        return this.http.get(url);
    }

    postPatientProcedure(appointment: AppointmentCreateDto): Observable<any> {
        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url;

        return this.http.post(url, appointment.toPayload());
    }

    cancelPatientProcedure(appointment: AppointmentCreateDto): Observable<any> {
        

        let url: string = this.appConfig.oc_api_url + environment.oc_api_appointments_url + "cancel";

        return this.http.post(url, appointment.toPayload());
    }

    getSuggestedReplies(appointmentId: string): Observable<AppointmentSuggestedReply[]> {
        

        let url: string = `${this.appConfig.oc_api_url}${environment.oc_api_appointments_url}${appointmentId}/suggested-replies`;

        return this.http.get<AppointmentSuggestedReply[]>(url);
    }

    getAISuggestedReplies(appointmentId: string): Observable<AppointmentSuggestedReply[]> {        

        let url: string = `${this.appConfig.oc_api_url}${environment.oc_api_appointments_url}${appointmentId}/ai-suggested-replies`;
        return this.http.get<AppointmentSuggestedReply[]>(url);
    }
}
